/**
 * The languages of the installation and their own names. Nothing else lives here,
 * so that the build can read the list too: the static site (site/) has a page per
 * language. To add a language, see docs/content-authoring.md, "Как добавить язык".
 */
export const LOCALES = ['en', 'ru', 'zh'] as const;
export type Locale = (typeof LOCALES)[number];

/** Each language's own name, shown in the language switcher whatever the current language. */
export const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  ru: 'Русский',
  zh: '中文',
};
